<template>
  <div id="app">
    <loading :isShow="showOrNot" />
    <page-kv :isShow="showOrNot" @triggerTrans='handleTrans' />
    <page-trans :isShow="showOrNot" :transFlag='startTrans' />
    <page-one :isShow="showOrNot" @sendImg="handleSendImg" />
    <page-two :isShow="showOrNot" :myGotSrc="gotImgSrc" />
    <wx-share :shareTitle="title" :shareDesc="desc" :shareImg="thumbImg" :shareLink="link" />
    <music-player :isShow="showOrNot" />
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import WxShare from './components/wxShare/wxShare';
import Loading from './pages/loading/loading'
import PageKV from './pages/page-kv/pageKV'
import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'
import PageTrans from './pages/page-trans/pageTrans'

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'page-trans': PageTrans,
    'wx-share': WxShare
  },
  data () {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isTRShow: false,
      },
      title: '梦中的婚礼',
      desc: 'DIY一个梦幻的婚礼现场！',
      thumbImg: 'https://www.jiandoukeji.com/h5/2019/dreamwedding/share/thumb.jpg',
      link: 'https://www.jiandoukeji.com/h5/2019/dreamwedding/',
      gotImgSrc: null,
      startTrans: false
    }
  },
  methods: {
    handleSendImg(msg) {
      this.gotImgSrc = msg;
    },
    handleTrans() {
      this.startTrans = true;
    }
  }
}
</script>

<style>
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  height: 100%;
}

canvas {
  width: 100%;
}
</style>
